import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'

/**
 * Modal to confirm the archiving of an OCR scoped job.
 */
export default class OCRConfirmArchiveModalViewModel extends ModalViewModel {
  constructor(
    private readonly onConfirm: () => unknown,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  confirm = () => {
    this.onConfirm()
    this.close()
  }
}
